// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21tbQ","left":"styles_left__1hYwW"};